<template>
    <span>Redirecting...</span>
</template>

<script>
export default {
  props: {
    eventId: { type: Number, required: true },
    learnerId: { type: Number, required: true },
  },
  created() {
    window.location.href = `${process.env.VUE_APP_WEBAPP_BASE_URL}/events/${this.eventId}/learners/${this.learnerId}`;
  },
};
</script>
